
type ModuleFn = (element: HTMLElement, dataset: DOMStringMap) => any;

declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

/**
 * Explicit-registry variant of createCycles for per-page bundles
 * (src/pages/*). Mounts only the modules passed in, so the page ships just
 * what it uses instead of the full import.meta.glob module scan. Uses the
 * same _moduleInitialized flag as createCycles, so the two never
 * double-mount an element.
 */
export function mountModules(
  registry: Record<string, ModuleFn>,
  dataAttribute = "module",
) {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      if (htmlElement._moduleInitialized) return null;

      const moduleFn = attributeValue ? registry[attributeValue] : undefined;
      if (!moduleFn) return null;

      try {
        htmlElement._moduleInitialized = true;
        return moduleFn(htmlElement, htmlElement.dataset);
      } catch (error) {
        delete htmlElement._moduleInitialized;
        console.warn(
          `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
          error,
        );
        return null;
      }
    })
    .filter((item) => item !== null);
}
